import type { IconSize } from './tokens'
import './system.css'

export function Icon({
  size = 'md',
  label,
  children,
}: {
  size?: IconSize
  label?: string
  children: string
}) {
  return (
    <span
      className={`icon icon--${size}`}
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
    >
      {children}
    </span>
  )
}
